import { ELanguage } from '../enums/language.enum';
import { ILanguage } from '../interfaces/language.interface';

export const LANGUAGES: ILanguage[] = [
  { fullname: 'English', key: ELanguage.EN, name: 'EN' },
  { fullname: 'German', key: ELanguage.DE, name: 'DE' }
];
